import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CuttingCustomHole, CuttingPanel, PositioningTypeEnum, SvgWorkspaceComponent, TexturePoint } from 'cloud-shared-lib';
import * as _ from 'lodash';

@Component({
  selector: 'csl-hole-group-schema-renderer',
  templateUrl: './hole-group-schema-renderer.component.html',
})
export class HoleGroupSchemaRendererComponent implements OnChanges, AfterViewInit {
  @ViewChild('svgWorkspace', { static: true }) svgWorkspace: SvgWorkspaceComponent;

  @Input() holes: CuttingCustomHole[] = [];
  @Input() positionType: PositioningTypeEnum;

  panel: CuttingPanel = new CuttingPanel();

  constructor() {
    this.panel.height = 500;
    this.panel.width = 500;
  }

  ngAfterViewInit(): void {
    this.redraw();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.holes?.currentValue || !_.isNil(changes?.positionType?.currentValue)) {
      this.redraw();
    }
  }

  getAxisCoordStart(): TexturePoint {
    const setType: PositioningTypeEnum = this.positionType;
    return {
      x: setType === PositioningTypeEnum.Free || setType === PositioningTypeEnum.FreeOnSide ? this.panel.height / 2 : 0,
      y: this.panel.width / 2,
    };
  }

  redraw(): void {
    const holesClone = _.cloneDeep(this.holes);
    this.panel.panelOutline.leftSide.customHoles = holesClone.map(h => {
      h.y += this.panel.width / 2;
      return h;
    });

    const currentType: PositioningTypeEnum = this.positionType;
    if (currentType === PositioningTypeEnum.Free || currentType === PositioningTypeEnum.FreeOnSide) {
      this.panel.panelOutline.leftSide.customHoles = holesClone.map(h => {
        h.x += this.panel.height / 2;
        return h;
      });
    }

    this.svgWorkspace.draw(this.panel);
  }
}
